/**
 * @fixme this is frontend only and should be moved to a more appropriate location
 */
const tooltipTitleMap = {
  // First index is expected/projected and second index is actual
  endingValue: ['Expected Ending Value', 'Actual Ending Value'],
  indemnity: ['Projected Indemnity', 'Actual Indemnity'],
  grossMargin: ['Projected Gross Margin', 'Actual Gross Margin'],
  grossMarginChange: [
    'Projected Gross Margin Change',
    'Actual Gross Margin Change',
  ],
}

/**
 * @fixme this is frontend only and should be moved to a more appropriate location
 */
export const getToolTipTitle = (
  key: keyof typeof tooltipTitleMap,
  value: number | null | undefined,
) => {
  const isActual = value !== null && value !== undefined
  if (isActual) {
    return tooltipTitleMap[key]?.[1] // index 1
  }
  return tooltipTitleMap[key]?.[0] // index 0
}
